"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImageFile = exports.isFileRenderable = exports.isVideoConversionCompleted = exports.isVideoConversionError = exports.isVideoConverted = exports.isVideoConversionPending = exports.isPdfMimeType = exports.isArchiveMimeType = exports.isAudioMimeType = exports.isVideoMimeType = exports.isGifMimeType = exports.isImageMimeType = exports.getFileIcon = exports.getFileIconColor = exports.getFileExtension = exports.getIconByFileType = exports.getFileType = exports.fileTypesInIFrame = exports.ICON_MISC = exports.FILE_TYPE_OTHER = exports.fileTypesWithoutIcon = exports.mimeTypeByExtension = exports.mimeTypesMap = void 0;
const filetypes_1 = require("./filetypes");
function convertToDictionary(array, value) {
    const result = {};
    array.forEach((key) => (result[key] = value));
    return result;
}
exports.mimeTypesMap = Object.assign(convertToDictionary(filetypes_1.ArchiveMimeTypes, "archive"), convertToDictionary(filetypes_1.CadMimeTypes, "cad"), convertToDictionary(filetypes_1.DwgMimeTypes, "dwg"), convertToDictionary(filetypes_1.CSVMimeTypes, "csv"), convertToDictionary(filetypes_1.DXFMimeTypes, "dxf"), convertToDictionary(filetypes_1.EPSMimeTypes, "eps"), convertToDictionary(filetypes_1.GifMimeTypes, "gif"), convertToDictionary(filetypes_1.ICSMimeTypes, "ics"), convertToDictionary(filetypes_1.IllustratorMimeTypes, "ai"), convertToDictionary(filetypes_1.ImageMimeTypes, "image"), convertToDictionary(filetypes_1.AudioMimeTypes, "audio"), convertToDictionary(filetypes_1.OpenDocumentMimeTypes, "gsheet"), convertToDictionary(filetypes_1.PdfMimeTypes, "pdf"), convertToDictionary(filetypes_1.PhotoshopMimeTypes, "psd"), convertToDictionary(filetypes_1.PowerpointMimeTypes, "powerpoint"), convertToDictionary(filetypes_1.SpreadsheetMimeTypes, "spreadsheet"), convertToDictionary(filetypes_1.SVGMimeTypes, "svg"), convertToDictionary(filetypes_1.TextMimeTypes, "text"), convertToDictionary(filetypes_1.TiffMimeTypes, "tiff"), convertToDictionary(filetypes_1.TtfMimeTypes, "ttf"), convertToDictionary(filetypes_1.VcardMimeTypes, "vcard"), convertToDictionary(filetypes_1.VideoMimeTypes, "video"), convertToDictionary(filetypes_1.WordMimeTypes, "word"), convertToDictionary(filetypes_1.XmlMimeTypes, "xml"), convertToDictionary(filetypes_1.XPSMimeTypes, "xps"), convertToDictionary(filetypes_1.SketchMimeTypes, "sketch"));
exports.mimeTypeByExtension = {
    skp: filetypes_1.SketchMimeTypes[0],
};
const fileTypeIcons = {
    archive: "archive",
    cad: "cad",
    dwg: "dwg",
    csv: "csv-color",
    dxf: "dxf",
    eps: "eps",
    gif: "gif",
    ai: "ai",
    ics: "ics-color",
    image: "image",
    audio: "audio",
    gsheet: "google-sheet",
    pdf: "pdf",
    psd: "ps",
    ps: "ps",
    powerpoint: "ptt",
    spreadsheet: "xlsx",
    svg: "svg",
    text: "text",
    tiff: "tiff",
    ttf: "ttf",
    vcard: "vcard-color",
    video: "video",
    word: "docx",
    xml: "xml-color",
    xps: "xps",
    sketch: "sketch",
};
const fileExtensionIcons = {
    ai: "ai",
    csv: "csv-color",
    sketch: "sketch",
};
const fileExtensionColors = {
    csv: "#17C4C4",
    vcf: "#FF9210",
};
const fileTypeColors = {
    video: "#17C4C4",
    image: "#3EAC40",
    word: "#26559C",
    pdf: "#FF1B00",
    spreadsheet: "#207245",
    powerpoint: "#D24625",
    archive: "#EC506E",
    xps: "#26559C",
    ai: "#FF7F18",
    psd: "#31C5F0",
    eps: "#FF9210",
    svg: "#883CD0",
    tiff: "#3EAC40",
    ttf: "#6A849B",
    dxf: "#0096D8",
    vcard: "#E04448",
    sketch: "#FDAD00",
    gsheet: "#23A566",
    csv: "#17C4C4",
    xml: "#EC506E",
    gif: "#883CD0",
    text: "#3A86FF",
    audio: "#4ECCFD",
    cad: "#E04448",
    dwg: "#E04448",
    misc: "#C7C8C9",
};
exports.fileTypesWithoutIcon = new Set([
    "image",
    "video",
    "audio",
    "word",
    "spreadsheet",
    "powerpoint",
    "pdf",
]);
exports.FILE_TYPE_OTHER = "other";
exports.ICON_MISC = "misc";
exports.fileTypesInIFrame = new Set([
    "word",
    "spreadsheet",
    "powerpoint",
]);
const getFileType = (mimetype) => { var _a; return (_a = exports.mimeTypesMap[mimetype]) !== null && _a !== void 0 ? _a : exports.FILE_TYPE_OTHER; };
exports.getFileType = getFileType;
const getIconByFileType = (fileType) => { var _a; return (_a = fileTypeIcons[fileType]) !== null && _a !== void 0 ? _a : exports.ICON_MISC; };
exports.getIconByFileType = getIconByFileType;
// Return file extension. Return empty string with files without extension - myfile/.htpassword
const getFileExtension = (fileName) => {
    if (!fileName)
        return "";
    const idx = fileName.lastIndexOf(".");
    if (fileName === "" || idx < 1) {
        return "";
    }
    return fileName.slice(idx + 1);
};
exports.getFileExtension = getFileExtension;
const getFileIconColor = (file) => {
    const ext = (0, exports.getFileExtension)(file.metadata.filename);
    const extColor = fileExtensionColors[ext];
    if (extColor)
        return extColor;
    const fileType = (0, exports.getFileType)(file.metadata.mimetype);
    const fileTypeColor = fileTypeColors[fileType];
    if (fileTypeColor)
        return fileTypeColor;
    return fileTypeColors.misc;
};
exports.getFileIconColor = getFileIconColor;
const getFileIcon = (file) => {
    const ext = (0, exports.getFileExtension)(file.metadata.filename);
    const extIcon = fileExtensionIcons[ext];
    if (extIcon)
        return extIcon;
    if ((0, exports.isVideoConversionError)(file))
        return exports.ICON_MISC;
    const fileType = (0, exports.getFileType)(file.metadata.mimetype);
    return (0, exports.getIconByFileType)(fileType);
};
exports.getFileIcon = getFileIcon;
const isImageMimeType = (mimetype) => exports.mimeTypesMap[mimetype] === "image";
exports.isImageMimeType = isImageMimeType;
const isGifMimeType = (mimetype) => exports.mimeTypesMap[mimetype] === "gif";
exports.isGifMimeType = isGifMimeType;
const isVideoMimeType = (mimetype) => exports.mimeTypesMap[mimetype] === "video";
exports.isVideoMimeType = isVideoMimeType;
const isAudioMimeType = (mimetype) => exports.mimeTypesMap[mimetype] === "audio";
exports.isAudioMimeType = isAudioMimeType;
const isArchiveMimeType = (mimetype) => exports.mimeTypesMap[mimetype] === "archive";
exports.isArchiveMimeType = isArchiveMimeType;
const isPdfMimeType = (mimetype) => exports.mimeTypesMap[mimetype] === "pdf";
exports.isPdfMimeType = isPdfMimeType;
const isVideoConversionPending = (file) => {
    return !!((0, exports.isVideoMimeType)(file.metadata.mimetype) &&
        (file === null || file === void 0 ? void 0 : file.video_conversion_status) &&
        ["pending", "none"].includes(file.video_conversion_status));
};
exports.isVideoConversionPending = isVideoConversionPending;
/**
 * Checks whether video file has been converted.
 *
 * For checking converted_video_handle instead of video_conversion_status property is used
 * because Filestack returns COMPLETED status even when video can't be converted.
 */
const isVideoConverted = (file) => {
    const isVideo = (0, exports.isVideoMimeType)(file.metadata.mimetype);
    return isVideo && !!file.converted_video_handle;
};
exports.isVideoConverted = isVideoConverted;
const isVideoConversionError = (file) => {
    const isVideo = (0, exports.isVideoMimeType)(file.metadata.mimetype);
    return isVideo && file.video_conversion_status === "error";
};
exports.isVideoConversionError = isVideoConversionError;
const isVideoConversionCompleted = (file) => {
    const isVideo = (0, exports.isVideoMimeType)(file.metadata.mimetype);
    return isVideo && file.video_conversion_status === "completed";
};
exports.isVideoConversionCompleted = isVideoConversionCompleted;
const isFileRenderable = (file) => {
    var _a;
    const mimetype = ((_a = file.metadata) === null || _a === void 0 ? void 0 : _a.mimetype) || "";
    const isIllustratorType = filetypes_1.IllustratorMimeTypes.includes(mimetype);
    const isTiffType = filetypes_1.TiffMimeTypes.includes(mimetype);
    if (isIllustratorType || isTiffType) {
        return false;
    }
    return !file.file_type || (0, exports.isImageFile)(file);
};
exports.isFileRenderable = isFileRenderable;
const isImageFile = (file) => {
    var _a;
    if (!((_a = file === null || file === void 0 ? void 0 : file.metadata) === null || _a === void 0 ? void 0 : _a.mimetype))
        return false;
    return ((0, exports.isImageMimeType)(file.metadata.mimetype) ||
        (0, exports.isGifMimeType)(file.metadata.mimetype));
};
exports.isImageFile = isImageFile;
